import { connect } from "react-redux";
import Tree from "../components/Tree/Tree";
import { setPage } from "../actions/research";

const mapStateToProps = state => {
  return {
    exercises: state.research.exercises.filter(
      item => item.category === "build"
    ),
    selected: state.research.selectedPage,
    title: "Build and Test"
  };
};

const mapDispatchToProps = {
  setPage
};

const BuildAndTestTree = connect(mapStateToProps, mapDispatchToProps)(Tree);

export default BuildAndTestTree;
